import React from 'react';
import { formatCurrency } from '../../../../lib/helpers/formatters';
import { useAuth } from '../../../../commons/Auth';

const TotalTr = ({
  totals = {},
  route = '',
  activeRoute = false,
  truncateTotals = false,
  profileType = '',
}) => {
  const [{ newIsAdmin }] = useAuth();
  const {
    cashedTotals = 0,
    netTotals = 0,
    grossTotals = 0,
    rateableTotals = 0,
    adminShareTotals = 0,
    earnedAdminShareTotals = 0,
    billableAdminShareTotals = 0,
  } = totals;

  return (
    <tr
      className="summary-tr"
      onClick={() => {
        return activeRoute === true
          ? (window.location.href = `${
              window.location.href.split('?')[0]
            }/${route}`)
          : null;
      }}
    >
      {!truncateTotals && newIsAdmin && profileType !== 'UTILIZER' && (
        <td>-</td>
      )}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && profileType === 'ASSOCIATION' && <td>-</td>}
      {!truncateTotals && profileType === 'ASSOCIATION' && <td>-</td>}
      {!truncateTotals && profileType === 'ASSOCIATION' && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && <td>-</td>}

      {newIsAdmin && (
        <td className="txt-table-right">{formatCurrency(rateableTotals)}</td>
      )}
      {newIsAdmin && (
        <td className="txt-table-right">{formatCurrency(netTotals)}</td>
      )}
      {profileType !== 'UTILIZER' && (
        <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
      )}
      {profileType !== 'UTILIZER' && (
        <td className="txt-table-right">
          {formatCurrency(earnedAdminShareTotals)}
        </td>
      )}
      {profileType !== 'UTILIZER' && (
        <td className="txt-table-right">
          {formatCurrency(billableAdminShareTotals)}{' '}
        </td>
      )}

      {!truncateTotals && newIsAdmin && profileType !== 'UTILIZER' && (
        <td>-</td>
      )}
      {!truncateTotals && newIsAdmin && profileType !== 'UTILIZER' && (
        <td>-</td>
      )}
    </tr>
  );
};

export default TotalTr;
